<template>
    <div class="loading-container">
        <v-progress-linear
                v-show="loading"
                height="3"
                indeterminate
                class="ma-0"
        ></v-progress-linear>
    </div>
</template>

<script>

    import { mapState, mapMutations } from 'vuex'

    export default{
        props: ['loading']
    }

</script>



<style scoped>
    .loading-container{
        padding: 0;
        height: 3px;
        width: 100%;
    }
</style>